// extracted by mini-css-extract-plugin
export default {"wrapper":"tab_wrapper__VK75M","tabs":"tab_tabs__0xx56","contents":"tab_contents__djymX"};